import dayjs from 'dayjs'
import { SERVER_DATE_TIME_FORMAT } from '@/components/desk/utils'

export const MAX_DAYS_DESK_BOOKING_LIMIT = 180

export const EventSaveTypes = {
  All: 0,
  Future: 1,
  CurrentOnly: -1
}

export function convertClientEventToServerEvent(clientEvent, infinityChecked = false) {
  const event = Object.assign({}, clientEvent)

  if (typeof event.remind === 'number' && event.start) {
    event.remind = event.start.add(clientEvent.remind, 'minute').format(SERVER_DATE_TIME_FORMAT)
  } else {
    event.remind = null
  }

  if (event.start) {
    event.start = infinityChecked ? dayjs().format(SERVER_DATE_TIME_FORMAT) : event.start.format(SERVER_DATE_TIME_FORMAT)
  }

  if (infinityChecked) {
    event.end = 'infinity'
  } else if (event.end) {
    event.end = event.end.format(SERVER_DATE_TIME_FORMAT)
  }

  return event
}

export function convertServerEventToClient(serverEvent) {
  const clientEvent = Object.assign({ key_: 1 }, serverEvent)
  if (clientEvent.start) {
    clientEvent.start = dayjs(clientEvent.start, SERVER_DATE_TIME_FORMAT)
  } else {
    const start = dayjs()
    const minutes = (Math.floor(start.minute() / 15) + 1) * 15
    clientEvent.start = start.minute(minutes)
  }

  if (clientEvent.end === 'infinity') {
    clientEvent.end = clientEvent.start.add(8, 'hour')
  }

  clientEvent.end = clientEvent.end ? dayjs(clientEvent.end, SERVER_DATE_TIME_FORMAT) : clientEvent.start.add(8, 'hour')

  clientEvent.remind =
    clientEvent.start && clientEvent.remind ? dayjs(clientEvent.remind, SERVER_DATE_TIME_FORMAT).diff(clientEvent.start, 'minute') : null

  return clientEvent
}

export function getDeskHeader(desk) {
  return `Desk ${desk.number ?? ''}`
}
